'use strict';

import Create from './reducers/create.js';
import * as Redux from 'redux';

export default Redux.createStore(Create);
